import React from 'react'
import { Link } from 'react-router-dom';

export default function TermsAndConditions() {
  return (
    <>
   <div className="container py-5">
  <h1 className="text-center heading mb-4">Terms and Conditions</h1>

  <h2 className="mt-4 privacy-heading">Welcome to Mentation Technologies!</h2>
  <p className="privacy-text">
    These terms and conditions outline the rules and regulations for the use
    of Mentation Technologies’ Website, located at &nbsp;
    <a href="https://mentationtech.in" target="_blank" rel="noopener noreferrer">
      www.mentationtech.in
    </a>.
  </p>
  <p className="privacy-text">
    By accessing this website, you agree to these terms and conditions. If you
    do not agree with any of the terms, please do not continue to use our
    website.
  </p>

  <h2 className="mt-4 privacy-heading">Cookies</h2>
  <p className="privacy-text">
    We use cookies to enhance your experience on our website. By using
    Mentation Technologies’ website, you consent to our use of cookies in
    accordance with our Privacy Policy.
  </p>

  <h2 className="mt-4 privacy-heading">Intellectual Property</h2>
  <p className="privacy-text">
    Unless stated otherwise, Mentation Technologies and/or its licensors own
    the intellectual property rights for all content on this website. You may
    access and use the content for personal or internal business purposes only.
  </p>
  <p className="privacy-text">You must not:</p>
  <ul>
    <li className="privacy-text mt-1">Republish or redistribute content from the website</li>
    <li className="privacy-text mt-1">Sell, rent, or sub-license any materials</li>
    <li className="privacy-text mt-1">Reproduce or copy materials for commercial purposes</li>
    <li className="privacy-text mt-1">Use content in a way that may mislead or harm others</li>
  </ul>

  <h2 className="mt-4 privacy-heading">Comments and Feedback</h2>
  <p className="privacy-text">
    Parts of this website allow users to post comments or feedback. These
    contributions reflect the opinions of the author and not Mentation
    Technologies. We do not guarantee the accuracy of user-generated content
    and reserve the right to remove inappropriate content.
  </p>

  <h2 className="mt-4 privacy-heading">Links to Other Websites</h2>
  <p className="privacy-text">
    Our website may contain links to third-party websites. Mentation Technologies
    is not responsible for the content or practices of these external sites.
  </p>

  <h2 className="mt-4 privacy-heading">Your Privacy</h2>
  <p className="privacy-text">
    Please review our <Link to="/privacy-policy">Privacy Policy</Link> to understand
    how we collect and use your personal information.
  </p>

  <h2 className="mt-4 privacy-heading">Disclaimer</h2>
  <p className="privacy-text">
    The website is provided “as is” without warranties of any kind, either
    express or implied. Mentation Technologies is not liable for any damages
    arising from the use of this site, to the fullest extent permitted by law.
  </p>

  <h2 className="mt-4 privacy-heading">Limitation of Liability</h2>
  <p className="privacy-text">
    Mentation Technologies will not be held responsible for any loss or
    damage resulting from the use of our website, including direct,
    indirect, incidental, or consequential damages.
  </p>

  <h2 className="mt-4 privacy-heading">Changes to Terms</h2>
  <p className="privacy-text">
    We may update these Terms and Conditions periodically. Users are encouraged
    to review this page regularly to stay informed of any changes.
  </p>
</div>

    </>
  )
}
